import { libraryItemLinksSet } from '../reducers/structuredDocumentDescriptionSlice';
import { getLibraryItemLinksByContentVersion } from '../services/structuredAnalysisService';

export const dispatchLibraryItemLinksSet = async (
  fetchLibraryItems,
  projectId,
  documentCode,
  contentId,
  contentVersionNumber,
  dispatch,
  isViewingAsClient
) => {
  if (fetchLibraryItems) {
    const libraryItemLinks = await getLibraryItemLinksByContentVersion(
      projectId,
      documentCode,
      contentId,
      contentVersionNumber,
      isViewingAsClient
    );
    dispatch(libraryItemLinksSet({ libraryItemLinks, documentCode }));
  } else {
    dispatch(libraryItemLinksSet({ libraryItemLinks: [], documentCode }));
  }
};
